import { SeloDoOrcamento } from '@/modulos/orcamento/Selo';

import type { SituacaoDaProposta, SituacaoDoEstudo } from './api';
import { NOME_DA_SITUACAO_DA_PROPOSTA, NOME_DA_SITUACAO_DO_ESTUDO, TOM_DA_SITUACAO_DA_PROPOSTA, TOM_DA_SITUACAO_DO_ESTUDO } from './renovacao';

/**
 * Os selos do módulo 20 (p.25): preenchidos, com o ponto e a palavra. São a
 * situação do ESTUDO e da PROPOSTA, e não um dos seis status da máquina: o
 * tom é o de retorno, como o selo da versão do orçamento (o mesmo componente).
 */
export function SeloDoEstudo({ situacao }: { readonly situacao: SituacaoDoEstudo }) {
  return <SeloDoOrcamento rotulo={NOME_DA_SITUACAO_DO_ESTUDO[situacao]} tom={TOM_DA_SITUACAO_DO_ESTUDO[situacao]} />;
}

export function SeloDaProposta({ situacao }: { readonly situacao: SituacaoDaProposta }) {
  return <SeloDoOrcamento rotulo={NOME_DA_SITUACAO_DA_PROPOSTA[situacao]} tom={TOM_DA_SITUACAO_DA_PROPOSTA[situacao]} />;
}

/** A marca A1: "Candidata a renovação" em âmbar, porque pede olhar — não decide nada. */
export function SeloDeCandidata() {
  return <SeloDoOrcamento rotulo="Candidata a renovação" tom="atencao" />;
}
